import React, { Component } from 'react';
class Head extends Component {
    render() { 
        return (
            
        <div className="menu -style-6">
            <div className="container">
                <div className="menu__wrapper text-center">
                    <div className="navigator">
                        <a className="menu__wrapper__logo" href="/">
                            <img src="/images/logo-white.png" alt="Logo" />
                        </a>
                    </div>
                </div>
            </div>
        </div> 
        );
    }
}
export default Head;